import React from 'react';

import useRibbonStyles from './useStyles';

export const DATA_TESTID = 'Ribbon';

type RibbonType = {
  children?: string;
  packageName: string;
};

export default function Ribbon({ children, packageName }: RibbonType): React.ReactElement {
  const { RibbonStyle } = useRibbonStyles({ packageName });
  return (
    <aside data-testid={DATA_TESTID} className={RibbonStyle}>
      <p>{children}</p>
    </aside>
  );
}
